/**
 * 模組頁面代碼 : 1210-UI-01
 * 頁面說明 : 案件資料清單列表頁面
 * @module modules/case/components/CasesPage
 */

// ----- import from npm modules -----
import React from 'react';
import $, {get} from 'jquery';

// ----- import from base libraries -----

import {useEffect, useState, useRef} from 'react';
import {useNavigate} from 'react-router-dom';

import enumList from 'web/utils/enumList';
import {useDispatch} from 'react-redux';
import {BaseComponent} from 'web/components/BaseComponent';
import {useCase} from 'web/modules/cases/hooks/useCase';

import {
  CASE_PRIORITY_HIGH,
  CASE_PRIORITY_NORMAL,
  FLG_CLOSE,
  FLG_OPEN,
} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';

const CasePage = (props) => {
  const {onDispatchList} = props;
  const dispatch = useDispatch();
  const baseComponent = new BaseComponent(props);
  const [searchCasePriority, setSearchCasePriority] = useState('');
  const [searchStartDate, setSearchStartDate] = useState('');
  const [searchEndDate, setSearchEndDate] = useState('');
  const [searchFlgStatus, setSearchFlgStatus] = useState('');
  const tableRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();
  const {caseList, getCaseList, onNewCase, handleSearch} = useCase(
    dispatch,
    showMessage,
    baseComponent,
  );

  const today = moment();

  useEffect(() => {
    baseComponent.checkPermission(
      enumList.moduleEnums.case,
      enumList.accessModeEnums.read,
    );
    // 預設填入今天
    getCaseList('', '', today, today);
    setSearchStartDate(today.format('YYYY-MM-DD'));
    setSearchEndDate(today.format('YYYY-MM-DD'));
    // getCaseList(searchCasePriority, searchFlgStatus, searchStartDate, searchEndDate);
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      const button = event.target.closest('.btn');
      if (button && button.id.startsWith('edit-case-') && caseList.length > 0) {
        const index = parseInt(button.id.split('-')[2]);
        const caseNumber = caseList[index].caseNumber;
        navigate(`/module/cases/${caseNumber}`);
      }
    };

    if (tableRef.current) {
      tableRef.current.addEventListener('click', handleClick);
    }

    return () => {
      if (tableRef.current) {
        tableRef.current.removeEventListener('click', handleClick);
      }
    };
  }, [caseList, navigate]);

  return (
    <section id="datatable-container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <svg
              className="nav__icon nav__icon--breadcrumb me-3"
              aria-hidden="true"
            >
              <use href="#ico-home-line"></use>
            </svg>
            AI智能派工
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            案件總覽
          </li>
        </ol>
      </nav>
      <h4>案件總覽</h4>
      <div className="datatable__search">
        <form
          className="d-flex gap-2 align-items-end needs-validation"
          noValidate
          onSubmit={handleSearch}
        >
          <div className="flex-fill w-100">
            <label htmlFor="searchCasePriority" className="form-label">
              等級
            </label>
            <select
              className="form-select form-select-sm"
              id="searchCasePriority"
              name="searchCasePriority"
              value={searchCasePriority}
              onChange={(e) => setSearchCasePriority(e.target.value)}
              required
            >
              <option disabled value="">
                請選擇
              </option>
              <option value="0">全部</option>
              <option value={enumList.casePriority.high}>
                {CASE_PRIORITY_HIGH}
              </option>
              <option value={enumList.casePriority.normal}>
                {CASE_PRIORITY_NORMAL}
              </option>
            </select>
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchFlgStatus" className="form-label">
              狀態
            </label>
            <select
              className="form-select form-select-sm"
              id="searchFlgStatus"
              name="searchFlgStatus"
              value={searchFlgStatus}
              onChange={(e) => setSearchFlgStatus(e.target.value)}
              required
            >
              <option disabled value="">
                請選擇
              </option>
              <option value="0">全部</option>
              <option value={enumList.caseFlgStatus.close}>{FLG_CLOSE}</option>
              <option value={enumList.caseFlgStatus.open}>{FLG_OPEN}</option>
            </select>
          </div>

          <div className="flex-fill w-100">
            <label htmlFor="searchStartDate" className="form-label">
              立案時間
            </label>
            <input
              type="date"
              className="form-control form-control-sm"
              id="searchStartDate"
              name="searchStartDate"
              value={searchStartDate}
              onChange={(e) => setSearchStartDate(e.target.value)}
            />
          </div>
          <div className="flex-fill w-100">
            <label htmlFor="searchEndDate" className="form-label"></label>
            <input
              type="date"
              className="form-control form-control-sm"
              id="searchEndDate"
              name="searchEndDate"
              value={searchEndDate}
              onChange={(e) => setSearchEndDate(e.target.value)}
            />
          </div>
          <div>
            <button className="btn btn-primary" type="submit">
              <svg className="btn__icon" aria-hidden="true">
                <use href="#ico-search"></use>
              </svg>
            </button>
          </div>
        </form>
      </div>
      <div className="datatable__tool">
        <div className="d-flex align-items-center gap-2"></div>
        <div className="d-flex align-items-center gap-2">
          {baseComponent.checkPermission(
            enumList.moduleEnums.case,
            enumList.accessModeEnums.create,
          ) && (
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              id="modalElevatorBtnNew"
              onClick={onDispatchList}
            >
              <svg className="btn__icon me-1" aria-hidden="true">
                <use href="#ico-code-circle-02"></use>
              </svg>
              指派條件
            </button>
          )}
          {baseComponent.checkPermission(
            enumList.moduleEnums.case,
            enumList.accessModeEnums.create,
          ) && (
            <button
              type="button"
              className="btn btn-sm btn-primary"
              id="modalElevatorBtnNew"
              onClick={onNewCase}
            >
              <svg className="btn__icon me-1" aria-hidden="true">
                <use href="#ico-plus-square"></use>
              </svg>
              新增
            </button>
          )}
        </div>
      </div>
      <div className="datatable__data" ref={tableRef}>
        <table
          id="datatable__caseList"
          className="display table table-hover align-middle nowrap"
        ></table>
      </div>
    </section>
  );
};

export default CasePage;
